// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__31oSE","legacyBtn":"MutateMid_legacyBtn__1KDT5"};